import React from 'react';
import './Projects.css';
import ProjectList from './ProjectList';

function Projects({getMediaList}) {
  const items = [
    {
      title: "Front-End Engineer | Kaioken",
      thumbnail: "https://johann-portfolio-react.s3.us-west-1.amazonaws.com/kaioken_web.png",
      media: [
        {
          index: 0,
          thumbnail: "https://johann-portfolio-react.s3.us-west-1.amazonaws.com/kaioken_web.png",
          original: "https://johann-portfolio-react.s3.us-west-1.amazonaws.com/kaioken_web.png", 
          description: "Kaioken Project : Webpage",
        },
        {
          index: 1,
          thumbnail: "https://johann-portfolio-react.s3.us-west-1.amazonaws.com/kaioken_web.png",
          original: "https://johann-portfolio-react.s3.us-west-1.amazonaws.com/kaioken_web.png", 
          embedUrl: "https://www.youtube.com//embed/x3edVjnkqlo?autoplay=1&showinfo=0",
          description: "Kaioken Project : Video (click to play)",
        },
      ],
      body: "• A front-end focused full-stack web MERN application for Dragon Ball fan page\n• Achieved optimal user experience on both mobile and web platforms through the implementation of responsive design using Media Query.\n• Prioritized UI and visualization, tailoring the front-end to meet the distinctive requirements of an anime fan page.",
      tags: ["JavaScript", "React.js", "Node.js", "Express.js", "MongoDB"]
    },
    {
      title: "Back-End Engineer | Stay In Style",
      thumbnail: null,
      media: [],
      body: "• A back-end focused full-stack web PERN application for room reservation services\n• Engineered system design for high request loads with low latency and error rates.\n• Reduced database query time by 70% using Postgres pool, eliminating bottlenecks.\n• Achieved 760rps with <1% error rate via horizontal scaling (2 proxies, 4 services).",
      tags: ["JavaScript", "React.js", "Node.js", "Express.js", "Postgres", "AWS EC2"]
    },
    {
      title: "Full-Stack Engineer | Harry BnB",
      thumbnail: "https://johann-portfolio-react.s3.us-west-1.amazonaws.com/carousel_web.png",
      media: [
        {
          index: 0,
          thumbnail: "https://johann-portfolio-react.s3.us-west-1.amazonaws.com/carousel_web.png",
          original: "https://johann-portfolio-react.s3.us-west-1.amazonaws.com/carousel_web.png", 
          description: 'HarryBnB Project : Carousel',
        },
        {
          index: 1,
          thumbnail: "https://johann-portfolio-react.s3.us-west-1.amazonaws.com/carousel_web.png",
          original: "https://johann-portfolio-react.s3.us-west-1.amazonaws.com/carousel_web.png", 
          embedUrl: "https://www.youtube.com/embed/_yF4oT3mRTw?autoplay=1&showinfo=0",
          description: "HarryBnB Project : Video (click to play)",
        },
      ],
      body: "• A front-end focused full-stack web MERN application for room reservation services\n• Built a responsive carousel with CSS animations and Media Query.\n• Enhanced team efficiency by decoupling modules using Styled Components.\n• Achieved instant data rendering in the browser with React.\n• Improved loading speeds by 70% with a Google speed test score of 99 / 100.",
      tags: ["JavaScript", "React.js", "Node.js", "Express.js", "MongoDB", "AWS EC2"]
    },
  ];

  return (
    <div id="projects">
      <h2 className="projects-title section-title white-text">Projects</h2>
      <div className="projects-body section-body">
        <ProjectList prjList={items} getMediaList={getMediaList}/>
        <a className="go-to-archive white-text" href="./archive" target="_self" rel="archive page">
          View Full Project Archive
          <span className="download-icon">
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              viewBox="0 0 20 20" 
              fill="currentColor" 
              stroke="currentColor" 
              strokeWidth="1.5" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              aria-hidden="true">
              <path d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h5.69l-7.22 7.22a.75.75 0 000 1.06z" />
            </svg>
          </span>
        </a>
      </div>
    </div>
  );
}

export default Projects;